import { render, staticRenderFns } from "./AlphabetDictationEdit.vue?vue&type=template&id=729740da&scoped=true&"
import script from "./AlphabetDictationEdit.vue?vue&type=script&lang=js&"
export * from "./AlphabetDictationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729740da",
  null
  
)

export default component.exports